import axios, { AxiosInstance } from "axios";
import { LoginRequest, Receipt, Filters } from "./Models";
import { getStoreValue } from "../utils/utils";

const ACCESS_TOKEN = 'smdc-jwt_access'
export class SMDCAPI {
  private static SMDC_INSTANCE: AxiosInstance;

  // static initialize() {
  //   SMDCAPI.SMDC_INSTANCE = axios.create({
  //     baseURL: process.env.REACT_APP_SMDC_API,
  //   });
  // }

  static initialize() {
    SMDCAPI.SMDC_INSTANCE = axios.create();
  }

  // START AUTH
  static login = async (request: LoginRequest) => {
    if (!SMDCAPI.SMDC_INSTANCE) {
      throw new Error("SMDC_INSTANCE is not initialized. Call SMDCAPI.initialize() before making requests.");
    }

    const response = await SMDCAPI.SMDC_INSTANCE.post("/admin/login", request);
    return response.data;
  }
  // END AUTH

  static getTransactions = async (accessToken: string, start: Date, end: Date) => {
    const URL = `/admin/transactions?&start=${start}&end=${end}`;

    if (!accessToken) {
      return
    } else {
      if (!SMDCAPI.SMDC_INSTANCE) {
        throw new Error("SMDC_INSTANCE is not initialized. Call SMDCAPI.initialize() before making requests.");
      }

      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json'
        }
      };

      const response = await SMDCAPI.SMDC_INSTANCE.get(URL, config);

      return response.data;
    }
  }

  static getFilteredTransactions = async (filters: Filters, accessToken: string) => {
    const URL = `/admin/transactions?searchTerm=${filters.searchValue}&start=${filters.start}&end=${filters.end}&type=${filters.type}&propertyName=${filters.properties}`;

    if (!accessToken) {
      return
    } else {
      if (!SMDCAPI.SMDC_INSTANCE) {
        throw new Error("SMDC_INSTANCE is not initialized. Call SMDCAPI.initialize() before making requests.");
      }

      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json'
        }
      };

      const response = await SMDCAPI.SMDC_INSTANCE.get(URL, config);

      return response.data;
    }
  }

  static getFilteredReports = async (filters: Filters, accessToken: string) => {
    const URL = `/admin/report?searchTerm=${filters.searchValue}&start=${filters.start}&end=${filters.end}&type=${filters.type}`;

    if (!accessToken) {
      return
    } else {
      if (!SMDCAPI.SMDC_INSTANCE) {
        throw new Error("SMDC_INSTANCE is not initialized. Call SMDCAPI.initialize() before making requests.");
      }

      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json'
        }
      };

      const response = await SMDCAPI.SMDC_INSTANCE.get(URL, config);

      return response.data;
    }
  }

  static getAutomaticPayments = async (accessToken: string, start: string | null, end: string | null, searchTerm: string | null, property: string | null) => {
    const URL = `/admin/recurringpayments?${start ? `start=${start}` : ''}${end ? `&end=${end}` : ''}${searchTerm ? `&searchTerm=${searchTerm}` : ''}${property ? `&propertyName=${property}` : ''}`;

    if (!accessToken) {
      return;
    } else {
      if (!SMDCAPI.SMDC_INSTANCE) {
        throw new Error("SMDC_INSTANCE is not initialized. Call SMDCAPI.initialize() before making requests.");
      }

      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json'
        }
      };

      const response = await SMDCAPI.SMDC_INSTANCE.get(URL, config);

      return response.data;
    }
  }

  static getAutomaticPaymentsReport = async (accessToken: string, start: string | null, end: string | null, searchTerm: string | null, property: string | null) => {
    const URL = `/admin/recurringpaymentsreport?${start ? `start=${start}` : ''}${end ? `&end=${end}` : ''}${searchTerm ? `&searchTerm=${searchTerm}` : ''}${property ? `&propertyName=${property}` : ''}`;

    if (!accessToken) {
      return
    } else {
      if (!SMDCAPI.SMDC_INSTANCE) {
        throw new Error("SMDC_INSTANCE is not initialized. Call SMDCAPI.initialize() before making requests.");
      }

      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json'
        }
      };

      const response = await SMDCAPI.SMDC_INSTANCE.get(URL, config);

      return response.data;
    }
  }

  static getReceipt = async (accessToken: string, paymentID: Receipt) => {
    const URL = `/admin/transactions/${paymentID}`;

    if (!accessToken) {
      return
    } else {
      if (!SMDCAPI.SMDC_INSTANCE) {
        throw new Error("SMDC_INSTANCE is not initialized. Call SMDCAPI.initialize() before making requests.");
      }

      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json'
        }
      };

      const response = await SMDCAPI.SMDC_INSTANCE.get(URL, config);

      return response.data;
    }
  }

  static getReceiptReports = async (accessToken: string, paymentID: Receipt) => {
    const URL = `/admin/report/${paymentID}`;

    if (!accessToken) {
      return
    } else {
      if (!SMDCAPI.SMDC_INSTANCE) {
        throw new Error("SMDC_INSTANCE is not initialized. Call SMDCAPI.initialize() before making requests.");
      }

      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json'
        }
      };

      const response = await SMDCAPI.SMDC_INSTANCE.get(URL, config);

      return response.data;
    }
  }

  static getProperyNames = async (accessToken: string) => {
    const URL = `/admin/tenant-properties`

    if (!accessToken) {
      return
    } else {
      if (!SMDCAPI.SMDC_INSTANCE) {
        throw new Error("SMDC_INSTANCE is not initialized. Call SMDCAPI.initialize() before making requests.");
      }

      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json'
        }
      };

      const response = await SMDCAPI.SMDC_INSTANCE.get(URL, config);

      return response.data;
    }
  }

  static getFormattedPropertyNames = async () => {
    const accessToken = await getStoreValue(ACCESS_TOKEN);
    try {
      const response = await this.getProperyNames(accessToken);
      if (response && Array.isArray(response)) {
        return response.map(property => ({ name: property.name }));
      }
      return [];
    } catch (error) {
      console.error('Failed to fetch property names:', error);
      return [];
    }
  }
}

// Initialize the SMDCAPI instance
SMDCAPI.initialize();
